import { FC } from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';

interface IRedirectingAuth {
	Logo: React.FC<React.SVGProps<SVGSVGElement>>;
}

const RedirectingAuth: FC<IRedirectingAuth> = ({ Logo }: IRedirectingAuth) => {
	return (
		<Box
			sx={{
				textAlign: 'center',
				height: '100vh',
				margin: 'auto',
				display: 'flex',
				flexFlow: 'column',
			}}
		>
			<Fade in timeout={400}>
				<Box sx={{ margin: 'auto' }}>
					<Box
						sx={{
							mb: 3,
						}}
					>
						<Logo />
					</Box>
					<Box sx={{ margin: 'auto' }}>
						<Box sx={{ display: 'inline-flex', flexGrow: 1 }}>
							<CircularProgress color='secondary' size={100} />
						</Box>
					</Box>
				</Box>
			</Fade>
		</Box>
	);
};

export default RedirectingAuth;
